import { render, staticRenderFns } from "./ExpensesTypeUpdate.vue?vue&type=template&id=5376bb4e&"
import script from "./ExpensesTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports